if (!customElements.get("single-initial")) {
  class ComponentSingleInitial extends HTMLElement {
    constructor() {
      super();
      // console.log("single initial");

      this.searchEndpoint = this.dataset.searchEndpoint;
      this.metalCodes = this.dataset.metalCodes
        ? this.dataset.metalCodes
            .split(",")
            .map((x) => ({ value: x.split(":")[0], code: x.split(":")[1] }))
        : [];
      this.variantImages = this.dataset.variantImages
        ? this.dataset.variantImages
            .split(",")
            .filter((v) => v)
            .map((v) => ({ value: v.split(":")[0], image: v.split(":")[1] }))
        : [];

      this.elProductAtcForm = document.querySelector("add-to-cart-form");
      this.elAtcButton = this.elProductAtcForm.querySelector(".add");
      this.elAtcButtonSticky = document.querySelector("product-sticky-panel .btn.add");

      this.selectedMetal = "";
      this.selectedLetter = "";
      this.selectedRingSize = "";

      this.elOptionMetals = this.querySelectorAll(
        '.metal-swatches input[type="radio"]'
      );
      this.elOptionValueMetals = this.querySelector(
        ".metal-swatches .option-value"
      );
      this.elOptionLetters = this.querySelectorAll(
        '.initials-swatches input[type="radio"]'
      );
      this.elOptionValueLetter = this.querySelector(".option-value-letter");
      this.elOptionRingSizes = this.querySelector(".product-ring-sizes select");
      this.elOptionValueRingSizes = this.querySelector(
        ".product-ring-sizes .option-value"
      );

      this.siCreateSoldOut()

      this.selectDefaultVariant();
      this.initBindings();

      setTimeout(() => {
        this.checkSelection();
      }, 500);
    }
    galleryV2Update(){
      if(this.elOptionMetals.length > 1){
        document.querySelectorAll(`.gallery-v2 img[alt*="${this.selectedMetal}"]`).forEach(item => {
          item.style.display = "block"
        })
        document.querySelectorAll(`.gallery-v2 img:not([alt*="${this.selectedMetal}"])`).forEach(item => {
          item.style.display = "none"
        })
      }
    }
    selectDefaultVariant() {
      const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });
      let letter = params.letter;

      if (letter) {
        let elLetter = Array.from(this.elOptionLetters).find(
          (el) => el.value.toLowerCase() === letter.toLowerCase()
        );

        if (elLetter) {
          elLetter.checked = true;
          this.selectedLetter = letter;
        }
      } else {
        Array.from(this.elOptionLetters)[0].checked = true;
        this.selectedLetter = Array.from(this.elOptionLetters)[0].value;
      }

      Array.from(this.elOptionMetals)[0].checked = true;

      this.selectedMetal = Array.from(this.elOptionMetals)[0].value;
      this.selectedRingSize = this.elOptionRingSizes.value;
      if(window?.ab_pdp && !notAbPdp){
      this.galleryV2Update()
      }
    }

    initBindings() {
      let self = this;

      // Binding Metal
      Array.from(this.elOptionMetals).forEach((el) => {
        el.addEventListener("change", (event) => {
          this.selectedMetal = event.currentTarget.checked
            ? event.currentTarget.value
            : null;
          if(window?.ab_pdp && !notAbPdp){
          self.galleryV2Update()
          }
          self.checkSelection();
        });
      });

      // Binding Ring Sizes
      this.elOptionRingSizes.addEventListener("change", (event) => {
        this.selectedRingSize = event.currentTarget.value;
        self.checkSelection();
      });

      // Binding Letters
      Array.from(this.elOptionLetters).forEach((el) => {
        el.addEventListener("change", (event) => {
          this.selectedLetter = event.currentTarget.checked
            ? event.currentTarget.value
            : null;
          if(window?.ab_pdp && !notAbPdp){
          self.galleryV2Update()
          }
          self.checkSelection();
        });
      });
    }

    validateSelectedOptions() {
      return this.selectedMetal && this.selectedLetter && this.selectedRingSize;
    }

    getMetalCode() {
      return this.metalCodes.find(
        (mc) =>
          mc.value.toLocaleLowerCase() === this.selectedMetal.toLowerCase()
      )?.code;
    }

    getSearchSku() {
      let metalCode = this.getMetalCode();
      if (!metalCode) return ``;
      return `R${metalCode}-DRD-${this.selectedLetter.toLocaleUpperCase()}-${
        this.selectedRingSize
      }`;
    }

    updateFormVars(selectedProduct, selectedVariant) {
      let productIdInputHidden = this.elProductAtcForm.querySelector(
        'input[name="product-id"]'
      );
      let variantIdInputHidden =
        this.elProductAtcForm.querySelector('input[name="id"]');
      if (productIdInputHidden) productIdInputHidden.value = selectedProduct.id;
      if (variantIdInputHidden) variantIdInputHidden.value = selectedVariant.id;

      Array.from(
        this.elProductAtcForm.querySelectorAll(".initial-ring-hidden-input")
      ).forEach((x) => x.remove());

      // adding properties
      let elLetterInputHidden = document.createElement("input");
      elLetterInputHidden.type = "hidden";
      elLetterInputHidden.name = "properties[Letter]";
      elLetterInputHidden.value = this.selectedLetter;
      elLetterInputHidden.classList.add("initial-ring-hidden-input");

      let elMetalInputHidden = document.createElement("input");
      elMetalInputHidden.type = "hidden";
      elMetalInputHidden.name = "properties[Metal Color]";
      elMetalInputHidden.value = this.selectedMetal;
      elMetalInputHidden.classList.add("initial-ring-hidden-input");

      let elRingSizeInputHidden = document.createElement("input");
      elRingSizeInputHidden.type = "hidden";
      elRingSizeInputHidden.name = "properties[Ring Size]";
      elRingSizeInputHidden.value = this.selectedRingSize;
      elRingSizeInputHidden.classList.add("initial-ring-hidden-input");

      this.elProductAtcForm.appendChild(elLetterInputHidden);
      this.elProductAtcForm.appendChild(elMetalInputHidden);
      this.elProductAtcForm.appendChild(elRingSizeInputHidden);

      

      let bundleImage = this.variantImages.find(
        (v) => v.value.toLowerCase() === this.selectedMetal.toLowerCase()
      );
      if (bundleImage) {
        let elBundleImageInputHidden = document.createElement("input");
        elBundleImageInputHidden.type = "hidden";
        elBundleImageInputHidden.name = "properties[_bundle_image]";
        elBundleImageInputHidden.value = bundleImage.image;
        elBundleImageInputHidden.classList.add("initial-ring-hidden-input");
        this.elProductAtcForm.appendChild(elBundleImageInputHidden);
      }
    }

    siCreateSoldOut() {
        let elButton1 = document.createElement('button');
        elButton1.classList.add('btn', 'flex', 'align-items-center', 'justify-content-center', 'one-whole', 'btn-sold-out');
        elButton1.innerHTML = 'Sold out';
        elButton1.disabled = true
        document.querySelector('.btn.add').insertAdjacentElement('afterend', elButton1)
        let elButton2 = document.createElement('button');
        elButton2.classList.add('btn', 'flex', 'align-items-center', 'justify-content-center', 'one-whole', 'btn-sold-out');
        elButton2.innerHTML = 'Sold out';
        elButton2.disabled = true
        document.querySelector('product-sticky-panel .btn.add').insertAdjacentElement('afterend', elButton2)
    }

    checkSelection() {
      if (this.validateSelectedOptions()) {
        // console.log({
        //   metal: this.selectedMetal,
        //   letter: this.selectedLetter,
        //   ringSize: this.selectedRingSize,
        // });

        this.elOptionValueMetals.innerHTML = this.selectedMetal;
        this.elOptionValueLetter.innerHTML = this.selectedLetter;
        this.elOptionValueRingSizes.innerHTML = this.selectedRingSize;

        this.dispatchEvent(
          new CustomEvent("selectionChange", {
            bubbles: true,
            cancelable: true,
            detail: {
              selectedOptions: {
                metal: this.selectedMetal,
                letter: this.selectedLetter,
                ringSize: this.selectedRingSize,
              },
            },
          })
        );

        let searchSku = this.getSearchSku();
        if (!searchSku) return "";
        let searchUrl = `/search/suggest.json?q=${encodeURIComponent(searchSku)}&resources[type]=product&resources[options][fields]=variants.sku&resources[limit]=10`;

        this.elAtcButton.disabled = true;
        this.elAtcButton.classList.add('hide');
        this.elAtcButtonSticky.disabled = true;
        this.elAtcButtonSticky.classList.add('hide');
        Array.from(document.querySelectorAll('.btn-sold-out')).forEach(el => el.classList.add('unhide'));

        $s.getJson({ url: searchUrl })
          .then((data) => {
            const products = data?.resources?.results?.products || [];
            if (products.length === 0) {
              this.dispatchEvent(new CustomEvent("singleInitialVariantNotFound", {
                bubbles: true, cancelable: true, detail: { sku: searchSku }
              }));
              return null;
            }
            return Promise.all(
              products.map(p => $s.getJson({ url: `${p.url.split('?')[0]}.js` }))
            );
          })
          .then((productDataList) => {
            if (!productDataList) return;
            let productData = null;
            let selectedVariant = null;
            for (const pd of productDataList) {
              const v = pd?.variants?.find(v => v.sku === searchSku);
              if (v) { productData = pd; selectedVariant = v; break; }
            }
            if (selectedVariant) {
              this.updateFormVars(productData, selectedVariant);
              this.dispatchEvent(new CustomEvent("singleInitialVariantChange", {
                bubbles: true, cancelable: true,
                detail: { variant: selectedVariant, product: productData }
              }));
              if (selectedVariant.available) {
                this.elAtcButton.disabled = false;
                this.elAtcButton.classList.remove('hide');
                this.elAtcButton.style.display = "";
                this.elAtcButtonSticky.disabled = false;
                this.elAtcButtonSticky.classList.remove('hide');
                Array.from(document.querySelectorAll('.btn-sold-out')).forEach(el => el.classList.remove('unhide'));
              }
            } else {
              this.dispatchEvent(new CustomEvent("singleInitialVariantNotFound", {
                bubbles: true, cancelable: true, detail: { sku: searchSku }
              }));
            }
            if (Array.isArray(productData?.tags) && productData.tags.includes('presale')) {
              document.querySelectorAll('product-buttons').forEach(pb => {
                pb.querySelectorAll('.add-to-cart').forEach(btn => {
                  if (!btn.classList.contains('hide')) btn.classList.add('hide');
                });
                let backInStock = pb.querySelector('.module.back-in-stock');
                if (backInStock && backInStock.classList.contains('hide')) backInStock.classList.remove('hide');
              });
            } else {
              document.querySelectorAll('product-buttons').forEach(pb => {
                pb.querySelectorAll('.add-to-cart').forEach(btn => {
                  if (btn.classList.contains('hide')) btn.classList.remove('hide');
                });
                let backInStock = pb.querySelector('.module.back-in-stock');
                if (backInStock && !backInStock.classList.contains('hide')) backInStock.classList.add('hide');
              });
            }
          })
          .catch((err) => {
            console.log("error", err);
          });
      }
    }
  }
  customElements.define("single-initial", ComponentSingleInitial);
}
